/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "../../../../../components/MDBox";
import FormField from "../../../../../components/FormField";
import React from "react";
import MDTypography from "../../../../../components/MDTypography";
// Material Dashboard 2 PRO React components


function CheckInForm({formData, members}) {

    const {formField, values, errors, touched} = formData;

    const {member_id} = formField;
    const {
        member_id: memberIdV,
    } = values;

    return (
        <MDBox mb={-2}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={member_id.type}
                        label={member_id.label}
                        name={member_id.name}
                        value={memberIdV}
                        options={members}
                        error={errors.member_id && touched.member_id}
                        success={memberIdV && memberIdV.length > 0 && !errors.member_id}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default CheckInForm;
